const initState = {
  status: 0
}

export default function(state = initState, action) {
  switch (action.type) {
    default:
      return state
  
  }
}


// WEBPACK FOOTER //
// ./src/reducers/auth.js